angular
  .module 'bookAndPay'
  .controller 'NewCartCtrl', (
    $scope,
    $state,
    $http,
    Restangular,
    $stateParams,
    DataService,
    newCart
  ) ->
    $scope.newCart = newCart.plain()
    $scope.message = $stateParams.flash
    $scope.user =
      cart_type: $scope.newCart.cart_type
      contact_email: $stateParams.ce || ''
      event_id: if $stateParams.eid then +$stateParams.eid else undefined
    Carts = Restangular.one('offers', $stateParams.uuid).all('carts')
    $scope.params = {}
    $scope.isPaymentOnly = $scope.newCart.cart_type is 'payment_only_cart'

    nextStep = (cartId) ->
      if $scope.isPaymentOnly || $scope.user.event_id
        $state.go 'bookAndPay.editCart', uuid: cartId, ct: $stateParams.ct
      else
        $state.go 'bookAndPay.showEvents', uuid: cartId

    $scope.submit = ->
      $scope.isLoading = true
      Carts.post($scope.user).then (cart) ->
        $scope.isLoading = false
        $scope.cart = cart
        if cart.matching_contacts.length < 2
          nextStep(cart.cart_uuid)
      , () ->
        $scope.isLoading = false

    $scope.selectContact = (id) ->
      url = "/websites/#{DataService.domain}/book_and_pay/carts/#{$scope.cart.cart_uuid}"
      $scope.cart.contact_id = id
      $http.put(url, cart: $scope.cart).then (response) ->
        nextStep(response.data.cart_uuid)
